export enum UserStatus {
  Active = 'Active',
  Pending = 'Pending',
  Suspended = 'Suspended',
  Abusive = 'Abusive',
  Blocked = 'Blocked',
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Revoked = 'Revoked',
  Inactive = 'Inactive',
  Waitlist = 'Waitlist',
}
